import * as React from 'react';

import { Button, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $quoteForm } from '../../_state/quoteForm.state';
import { useTranslations } from '../../i18n/useTranslations';
import { QuoteFormState } from '../../types/quote';

type Props = {
  isSaving?: boolean;
  onSaveUpdates?: (data?: QuoteFormState) => void;
  onDiscard?: () => void;
};

export const QuoteFormFooterActions: React.FC<Props> = ({
  isSaving,
  onSaveUpdates,
  onDiscard,
}) => {
  const t = useTranslations();
  const form = useAtomValue($quoteForm);

  return (
    <div
      className={cn(
        '@QuoteFormFooterActions',
        'sticky bottom-0 mt-5 flex flex-0 justify-end gap-3 border-t border-neutral/10 bg-white px-6 pt-5 pb-5',
      )}
    >
      <Button
        color="neutral"
        variant="outline"
        onPress={() => onDiscard?.()}
        isDisabled={isSaving}
      >
        {t.quotes.detail.footer.discard}
      </Button>
      <Button
        color="primary"
        variant="solid"
        onPress={() => onSaveUpdates?.(form)}
        isPending={isSaving}
        isLoading={isSaving}
      >
        {t.quotes.detail.footer.saveUpdates}
      </Button>
    </div>
  );
};
